import React, { Component } from "react";
import { Link } from "react-router-dom";
import { termsOfUse } from "./services";
import { FiChevronRight } from "react-icons/fi";
import Tab from "react-bootstrap/esm/Tab";
import { Nav } from "react-bootstrap";
import Spinner from "../../base/features/micro/Spinner";
import Empty from "../../base/features/blocks/Empty";

class TermsOfUse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersTerms: null,
      sellersTerms: null,
      defaultActiveKey: "user",
    };
  }
  componentDidMount() {
    this.getTerms();
  }
  getTerms() {
    termsOfUse().then((items) => {
      items &&
        this.setState({
          usersTerms: items.users,
          sellersTerms: items.sellers,
        });
    });
  }
  render() {
    return (
      <div className="container-fluid px-0">
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0" }}
        >
          <div className="col-auto align-self-center px-0">
            <Link
              to={window.history.length < 3 && "/setting"}
              onClick={() => {
                window.history.length > 3 && window.history.back();
              }}
            >
              <FiChevronRight size="26" className="" />
            </Link>
          </div>

          <div className="col align-self-center text-center px-0">
            <h1 className="fs-6 fw-bold mb-0">قوانین و مقررات</h1>
          </div>
        </header>
        <body style={{ marginTop: "52px" }}>
          <div className="row mx-0 p-0">
            <div className="col-12 px-0">
              <Tab.Container
                className="border-0 w-100"
                activeKey={this.state.defaultActiveKey}
                onSelect={(i) => this.setState({ defaultActiveKey: i })}
                defaultActiveKey={this.state.defaultActiveKey}
                id="tab-example1"
              >
                <div
                  className="row mx-0 bg-white position-sticky"
                  style={{ top: "51px" }}
                >
                  <div className="col-6 text-center px-0">
                    <Nav.Link
                      className={
                        "p-3 fw-bolder fs-6 " +
                        (this.state.defaultActiveKey === "user"
                          ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                          : "text-muted")
                      }
                      eventKey="user"
                    >
                      کاربران
                    </Nav.Link>
                  </div>
                  <div className="col-6 text-center px-0">
                    <Nav.Link
                      className={
                        "p-3 fw-bolder fs-6 " +
                        (this.state.defaultActiveKey === "seller"
                          ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                          : "text-muted")
                      }
                      eventKey="seller"
                    >
                      فروشندگان
                    </Nav.Link>
                  </div>
                </div>

                <div className="row mx-0">
                  <div className="col-12 p-4">
                    <Tab.Content>
                      <Tab.Pane eventKey="user">
                        {this.state.usersTerms ? (
                          this.state.usersTerms.length === 0 ? (
                            <Empty text={"موردی یافت نشد"} />
                          ) : (
                            this.state.usersTerms.map((term, t) => (
                              <div>
                                <h2 className="fw-bold fs-4">{term.title}</h2>
                                <p
                                  className="fw-bold text-muted"
                                  style={{
                                    whiteSpace: "pre-wrap",
                                    lineHeight: "1.7em",
                                  }}
                                >
                                  {term.des}
                                </p>
                              </div>
                            ))
                          )
                        ) : (
                          <Spinner />
                        )}
                      </Tab.Pane>
                      <Tab.Pane eventKey="seller">
                        {this.state.sellersTerms ? (
                          this.state.sellersTerms.length === 0 ? (
                            <Empty text={"موردی یافت نشد"} />
                          ) : (
                            this.state.sellersTerms.map((term, t) => (
                              <div>
                                <h2 className="fw-bolder fs-4">{term.title}</h2>
                                <p
                                  className="fw-bolder text-muted"
                                  style={{
                                    whiteSpace: "pre-wrap",
                                    lineHeight: "1.7em",
                                  }}
                                >
                                  {term.des}
                                </p>
                              </div>
                            ))
                          )
                        ) : (
                          <Spinner />
                        )}
                      </Tab.Pane>
                    </Tab.Content>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
        </body>
      </div>
    );
  }
}

export default TermsOfUse;
